import request from '@/request'

// 获取用户菜单
export function getMenu(lang) {
  return request({
    url: `/menu/getMenu?lang=${lang}`,
    method: 'get'
  })
}

// 检查用户是否拥有某菜单访问权
export function checkMenuAccess(route) {
  return request({
    url: `/menu/checkMenuAccess?route=${route}`,
    method: 'get'
  })
}

// 根据当前登录的用户id获取权限菜单（OC） 游客可不传userId 1824271872129372160
export function getMenuAllAPI(userId='') { 
  return request({
    url: `/menu/getMenuAll`,
    method: 'get',
    params: {
      userId
    }
  })
}

// 根据当前角色获取所有的权限字符列表（OC） 
export function getUSrPermissionCharacterAPI(userId='') { 
  return request({
    url: `/menu/getUSrPermissionCharacter`,
    method: 'get',
    params: {
      userId
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/menu.js